import { client } from '@/client';
import { resolveData } from '@/util/api-helpers';

export async function indexDefinitions() {
   return client.get('/api/priorities/definitions')
      .then(resolveData);
}

export async function index() {
   return client.get('/api/priorities')
      .then(resolveData);
}

export async function indexCompany({ slug }) {
   return client.get(`/api/priorities/${slug}`)
      .then(resolveData);
}

export async function storePriority(company, params) {
   return client.post(`/api/priorities/${company.slug}`, params)
      .then(resolveData);
}

export async function updatePriority(company, priority, params) {
   return client.put(`/api/priorities/${company.slug}/${priority.id}`, params)
      .then(resolveData);
}

export async function reorder(company, priorities) {
   return client.put(`/api/priorities/${company.slug}/reorder`, {
      order: priorities.map(item => item.id),
   })
      .then(resolveData);
}

export async function deletePriority(company, priority) {
   return client.delete(`/api/priorities/${company.slug}/${priority.id}`)
      .then(resolveData);
}
